import { observer } from 'mobx-react';
import { useEffect } from 'react';
import foodicsLogStore from './store/foodicsLogStore';
// import FoodicsLogHeader from 'src/view/screens/FoodicsLogScreen/screens/FoodicsLog/containers/FoodicsLogHeader/FoodicsLogHeader';
import FoodicsLogList from 'src/view/screens/FoodicsLogScreen/screens/FoodicsLog/containers/FoodicsLogList/FoodicsLogList';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { SCREENS } from '~/constants/screens';
import { Integrations } from '~/constants/integrations';

const FoodicsLog = (): JSX.Element => {
  useEffect(() => {
    foodicsLogStore.fetchFoodicsLogList();
  }, []);

  return (
    <>
      <Headers>
        <HeaderBack title="foodics_log" path={SCREENS.SETTINGS_INTEGRATION(Integrations.FOODICS)} />
      </Headers>
      {/* <div className="mt-6"></div> */}
      {/* <FoodicsLogHeader /> */}
      <FoodicsLogList />
    </>
  );
};

export default observer(FoodicsLog);
